import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import GoToSummaryButton, { type GoToSummaryButtonProps } from '@/components/ui/go-to-summary-button';
import { useIsPeriodicReview } from '@/features/periodic-review/context';
import { useProfilePeriodicReviewAml } from '@/hooks/queries/use-profile-periodic-review';

const PeriodicReviewGoToSummaryButton = <T extends FieldValues>(props: GoToSummaryButtonProps<T>) => {
  const isPeriodicReview = useIsPeriodicReview();
  const { data: aml } = useProfilePeriodicReviewAml(isPeriodicReview);
  const { t } = useTranslation();

  // The AML answers are the last section, so a draft of them means the customer has been through every section
  if (!aml?.date) return null;

  return (
    <GoToSummaryButton incompleteSectionMessage={t('periodicReview.summary.incompleteSection')} {...props}>
      {t('periodicReview.summary.goToSummary')}
    </GoToSummaryButton>
  );
};
PeriodicReviewGoToSummaryButton.displayName = 'PeriodicReviewGoToSummaryButton';

export default PeriodicReviewGoToSummaryButton;
